import { render, staticRenderFns } from "./VerifyForm.vue?vue&type=template&id=67a645b0&"
import script from "./VerifyForm.vue?vue&type=script&lang=js&"
export * from "./VerifyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67a645b0')) {
      api.createRecord('67a645b0', component.options)
    } else {
      api.reload('67a645b0', component.options)
    }
    module.hot.accept("./VerifyForm.vue?vue&type=template&id=67a645b0&", function () {
      api.rerender('67a645b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/layout/VerifyForm.vue"
export default component.exports